'use client';

function activateStylesheet(element: HTMLStyleElement | null) {
  if (!element) return;

  element.media = '';

  // Activity retains the element when its route is hidden.
  return () => {
    element.media = 'not all';
  };
}

export function PageGlobalStyle({ children }: { children: string }) {
  return <style ref={activateStylesheet}>{children}</style>;
}
